import script from "./goRinSyo0042.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0042.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0042.vue?vue&type=style&index=0&id=45efce3e&lang=scss"

const __exports__ = script;

export default __exports__